/** Vibration API ラッパー。サポートしていない環境では無視する */
export const haptic = (pattern: number | number[] = 10): void => {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate(pattern);
  }
};
